import axios from "../http";
const API_URL = process.env.REACT_APP_apiUrl;

export async function createHospital(fields) {
  const url = `${API_URL}admins/hospitals`;
  let response = await axios.post(url, fields);
  return response.data;
}

export async function getHospitals(page, search = false, limit = 10) {
  let params = "page=" + page + "&limit=" + limit;
  if (search) {
    params += "&search=" + search;
  }
  const url = `${API_URL}admins/hospitals?` + params;
  let response = await axios.get(url);
  return response.data;
}

export async function getAllHospitals() {
  const url = `${API_URL}admins/hospitals`;
  let response = await axios.get(url);
  return response.data;
}

export async function deleteHospital(id) {
  const url = `${API_URL}admins/hospital/` + id;
  let response = await axios.delete(url);
  return response.data;
}

export async function updateHospital(fields, id) {
  const url = `${API_URL}admins/hospital/` + id;
  let response = await axios.patch(url, fields);
  return response.data;
}

export async function getHospitalById(id) {
  let res = await getAllHospitals();
  let obj = res.data.result.find((el) => el._id == id);
  return obj;
}

export async function createAppointmentMode(fields) {
  const url = `${API_URL}admins/appointment-modes`;
  let response = await axios.post(url, fields);
  return response.data;
}

export async function getAppointmentModes(
  page,
  search = false,
  hospital_id = false,
  limit = 10,
) {
  let params = "page=" + page + "&limit=" + limit;
  if (search) {
    params += "&search=" + search;
  }
  if (hospital_id) {
    params += "&hospitalId=" + hospital_id;
  }
  const url = `${API_URL}admins/appointment-modes?` + params;
  let response = await axios.get(url);
  return response.data;
}

export async function getAllAppointmentModes() {
  const url = `${API_URL}admins/appointment-modes`;
  let response = await axios.get(url);
  return response.data;
}

export async function deleteAppointmentMode(id) {
  const url = `${API_URL}admins/appointment-mode/` + id;
  console.log(url);
  let response = await axios.delete(url);
  return response.data;
}

export async function updateAppointmentMode(fields, id) {
  const url = `${API_URL}admins/appointment-mode/` + id;
  let response = await axios.patch(url, fields);
  return response.data;
}

export async function getAppointmentModeById(id) {
  let res = await getAllAppointmentModes();
  let obj = res.data.result.find((el) => el && el._id == id);
  return obj;
}

export async function createSpecialization(fields) {
  const url = `${API_URL}admins/specializations`;
  let response = await axios.post(url, fields);
  return response.data;
}

export async function getSpecializations(
  page,
  search = false,
  hospital_id = false,
  limit = 10,
) {
  let params = "page=" + page + "&limit=" + limit;
  if (search) {
    params += "&search=" + search;
  }
  if (hospital_id) {
    params += "&hospitalId=" + hospital_id;
  }
  const url = `${API_URL}admins/specializations?` + params;
  let response = await axios.get(url);
  return response.data;
}

export async function getAllSpecializations() {
  const url = `${API_URL}admins/specializations`;
  let response = await axios.get(url);
  return response.data;
}

export async function deleteSpecialization(id) {
  const url = `${API_URL}admins/specialization/` + id;
  console.log(url);
  let response = await axios.delete(url);
  return response.data;
}

export async function updateSpecialization(fields, id) {
  const url = `${API_URL}admins/specialization/` + id;
  let response = await axios.patch(url, fields);
  return response.data;
}

export async function getSpecializationById(id) {
  let res = await getAllSpecializations();
  let obj = res.data.result.find((el) => el && el._id == id);
  return obj;
}

export async function createDoctor(fields) {
  const url = `${API_URL}admins/doctors`;
  let response = await axios.post(url, fields);
  return response.data;
}

export async function getDoctors(
  page,
  search = false,
  hospital_id = false,
  Appointment_id = false,
  specialization_id = false,
  limit = 10,
) {
  let params = "page=" + page + "&limit=" + limit;
  if (search) {
    params += "&search=" + search;
  }
  if (hospital_id) {
    params += "&hospitalId=" + hospital_id;
  }
  if (Appointment_id) {
    params += "&Appointment_id=" + Appointment_id;
  }
  if ((specialization_id = false)) {
    params += "&specialization_id" + hospital_id;
  }
  const url = `${API_URL}admins/doctors?` + params;
  let response = await axios.get(url);
  return response.data;
}

export async function getAllDoctors() {
  const url = `${API_URL}admins/doctors`;
  let response = await axios.get(url);
  return response.data;
}

export async function deleteDoctor(id) {
  const url = `${API_URL}admins/doctor/` + id;
  console.log(url);
  let response = await axios.delete(url);
  return response.data;
}

export async function updateDoctor(fields, id) {
  const url = `${API_URL}admins/doctor/` + id;
  let response = await axios.patch(url, fields);
  return response.data;
}

export async function getDoctorById(id) {
  let res = await getAllDoctors();
  let obj = res.data.result.find((el) => el && el._id == id);
  return obj;
}
